import Coloris from "@melloware/coloris";
import { Txt } from "../../common/text";
import { EditControl } from "../form-row";
import { Helper } from "../../common/helper";

export class ColorEditControl implements EditControl
{
    private readonly input: HTMLInputElement;
    private readonly changeActions: (() => void)[] = [];

    constructor()
    {
        this.input = document.createElement("input");
        this.input.type = "text";
        this.input.className = "w-form-control";
    }

    initialize(parent: HTMLElement)
    {
        parent.append(this.input);

        Coloris({
            el: this.input,
            theme: Helper.isMobileScreen() ? "default" : "pill",
            themeMode: "light",
            format: "hex",
            alpha: false,
            clearButton: true,
            clearLabel: Txt.clear,
            swatches: [
                "#f8d0d0", "#f8d7bc", "#f8ebc6", "#d0eed0", "#d0dff8", "#e2d0f8",
                "#f09090", "#f0b690", "#f0d790", "#90f090", "#90c0f0", "#c090f0"]
        });

        // The app's dialogs open with <dialog>.showModal(), which renders them in
        // the browser's top layer. Coloris keeps a single shared picker element that
        // lives on <body> by default; there it would sit behind the modal and be
        // unclickable. Move it into the current dialog right before it opens. The
        // capture-phase listener runs before Coloris's own click handler, so the
        // picker is already re-parented when it positions itself.
        this.input.addEventListener("click", () =>
        {
            const dialog = this.input.closest("dialog");
            (Coloris as unknown as (opts: { parent: HTMLElement }) => void)(
                { parent: dialog ?? document.body }
            );
        }, true);

        this.input.addEventListener("change", () =>
        {
            for (const action of this.changeActions)
            {
                action();
            }
        });
    }

    async setValue(value: string)
    {
        this.input.value = value ?? "";
        this.input.dispatchEvent(new Event("input", { bubbles: true }));
    }

    getValue()
    {
        return this.input.value || null;
    }

    onChange(action: () => void)
    {
        this.changeActions.push(action);
    }

    focus()
    {
        this.input.focus();
    }
}
